<template>
    <v-card flat>
        <v-overlay :value="loadingShopData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{ activeShop.name }} ({{ activeShop.address }})</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                dark
                color="bal-red"
                @click="editProduct"
                :disabled="tabName === 'Files'"
                v-if="hasPermissionForAction(PermissionsConstants.SHOP, PermissionsConstants.EDIT)"
            >
                <v-icon>edit</v-icon>
                {{ "Edit" | t }}
            </v-btn>
            <v-menu
                offset-y
                bottom
                left
                v-if="hasPermissionForAction(PermissionsConstants.SHOP, PermissionsConstants.DELETE)"
            >
                <template v-slot:activator="{ on }">
                    <v-btn color="bal-dark-gray" class="px-2 ml-2 mx-2" style="min-width: 0;" dark v-on="on">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="handleDeleteClick">
                        <v-list-item-title style="color: red">{{ "Delete" | t }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "General info" | t }}
            </v-tab>
            <v-tab-item>
                <general-info-tab />
                <chart-view v-if="activeShop && activeShop.import_rows && activeShop.import_rows.length > 0" />
            </v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "Store info" | t }}
            </v-tab>
            <v-tab-item>
                <store-info-tab />
            </v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "Contacts info" | t }}
            </v-tab>
            <v-tab-item>
                <contacts-info-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import Store from "../../store";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import GeneralInfoTab from "./shops-admin-tab-items/general-info-tab";
import ContactsInfoTab from "./shops-admin-tab-items/contacts-info-tab";
import StoreInfoTab from "./shops-admin-tab-items/store-info-tab";
import ChartView from "./shops-admin-tab-items/chart-view";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "shops-admin-view",
    components: { ChartView, StoreInfoTab, GeneralInfoTab, ContactsInfoTab },
    data() {
        return {
            tab: 0,
            tabs: ["General info", "Store info", "Contacts info"]
        };
    },
    async mounted() {
        await document.addEventListener("keydown", this.nextTab);
        await Store.dispatch("ShopsAdminStore/getShopData", this.$route.params.shopId);
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.nextTab);
    },
    computed: {
        ...mapState("ShopsAdminStore", ["activeShop", "loadingShopData", "searchShopString", "tableOptions"]),
        ...mapState(["countries"]),
        tabName() {
            return this.tabs[this.tab];
        },
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        ...mapMutations("ShopsAdminStore", ["resetActiveShop"]),
        closeDrawer() {
            this.resetActiveShop();
            this.$router.push({ name: "shops-admin-list" });
        },
        editProduct() {
            this.$router.push({
                name: "shops-admin-edit",
                params: { productId: this.$route.params.shopId, tab: this.tabs[this.tab] }
            });
        },
        nextTab(e) {
            if (e.keyCode === 69 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.editProduct();
            }
            if (e.key === "ArrowLeft") {
                if (this.tab > 0) {
                    this.tab -= 1;
                }
            } else if (e.key === "ArrowRight") {
                if (this.tab + 1 < this.tabs.length) {
                    this.tab += 1;
                }
            }
        },
        handleDeleteClick() {
            if (confirm("Are you sure you want to delete this product?")) {
                const promise = new Promise((resolve, reject) => {
                    let resp = Store.dispatch("ShopsAdminStore/deleteProduct", {
                        shop_id: this.activeShop.id
                    });
                    if (resp) {
                        resolve(resp);
                    } else {
                        reject(Error("Error"));
                    }
                });

                promise.then(
                    result => {
                        this.$router.push({
                            name: "shops-admin-list"
                        });
                        Store.dispatch("ShopsAdminStore/getShopsList", {
                            options: this.tableOptions,
                            search: this.searchShopString
                        });
                    },
                    err => {
                        console.log(err);
                    }
                );
            }
        }
    }
};
</script>

<style scoped></style>
